export const STARTER = [
    {
        country: "Argentina",
        keywords: [],
        price: 0.146
    },
    {
        country: "Brazil",
        keywords: [],
        price: 0.147
    },
    {
        country: "Chile",
        keywords: [],
        price: 0.18
    },
    {
        country: "Colombia",
        keywords: [],
        price: 0.084
    },
    {
        country: "Egypt",
        keywords: [],
        price: 0.203
    },
    {
        country: "France",
        keywords: [],
        price: 0.248
    },
    {
        country: "Germany",
        keywords: [],
        price: 0.239
    },
    {
        country: "India",
        keywords: [],
        price: 0.082
    },
    {
        country: "Indonesia",
        keywords: [],
        price: 0.12
    },
    {
        country: "Israel",
        keywords: [],
        price: 0.113
    },
    {
        country: "Italy",
        keywords: [],
        price: 0.155
    },
    {
        country: "Malaysia",
        keywords: [],
        price: 0.176
    },
    {
        country: "Mexico",
        keywords: [],
        price: 0.123
    },
    {
        country: "Netherlands",
        keywords: [],
        price: 0.268
    },
    {
        country: "Nigeria",
        keywords: [],
        price: 0.133
    },
    {
        country: "Pakistan",
        keywords: [],
        price: 0.128
    },
    {
        country: "Peru",
        keywords: [],
        price: 0.157
    },
    {
        country: "Russia",
        keywords: [],
        price: 0.169
    },
    {
        country: "Saudi Arabia",
        keywords: [],
        price: 0.126
    },
    {
        country: "South Africa",
        keywords: [],
        price: 0.116
    },
    {
        country: "Spain",
        keywords: [],
        price: 0.146
    },
    {
        country: "Turkey",
        keywords: [],
        price: 0.082
    },
    {
        country: "United Arab Emirates",
        keywords: [],
        price: 0.117
    },
    {
        country: "United Kingdom",
        keywords: [
           "ngland",
            "northern ireland",
            "scotland",
            "wales"
        ],
        "price": 0.135
    },
    {
        country: "North America",
        keywords: [
           "nited states, usa, canada"
        ],
        "price": 0.1
    },
    {
        country: "Rest of Africa",
        keywords: [],
        price: 0.097
    },
    {
        country: "Rest of Asia Pacific",
        keywords: [],
        price: 0.16
    },
    {
        country: "Rest of Central & Eastern Europe",
        keywords: [],
        price: 0.176
    },
    {
        country: "Rest of Latin America",
        keywords: [],
        price: 0.161
    },
    {
        country: "Rest of Middle East",
        keywords: [],
        price: 0.111
    },
    {
        country: "Rest of Western Europe",
        keywords: [],
        price: 0.143
    },
    {
        country: "Other",
        keywords: [],
        price: 0.144
    }
];